import React from 'react';
import { Body5 } from '../../../common/typography';
import { DropdownSingle } from '../../../common/sharedComponents/DropdownSingle';
import { IDropdownOption } from '../../../@types/dropdown';
import {
  MealPeriodDropdownContainer,
  MealPeriodTitle,
} from './MealPeriodDropdown.styled';
import { useTranslation } from 'react-i18next';

interface IMealPeriodDropdown {
  handleMealPeriod?: (option: IDropdownOption) => void;
  defaultOption?: IDropdownOption;
  disabled?: boolean;
}

export function MealPeriodDropdown ({
  handleMealPeriod,
  defaultOption,
  disabled,
}: IMealPeriodDropdown) {
  const { t } = useTranslation();
  const mealPeriodOption: IDropdownOption[] = [
    { value: 'breakfast', label: 'Breakfast' },
    { value: 'lunch', label: 'Lunch' },
    { value: 'dinner', label: 'Dinner' },
  ];

  return (
    <MealPeriodDropdownContainer>
      <MealPeriodTitle>
        <Body5 color="eerieBlack">
          {t('COMMON.MY_AUDIT.SECTIONS.MEAL_PERIOD')}
        </Body5>
      </MealPeriodTitle>
      <DropdownSingle
        options={mealPeriodOption}
        defaultOption={defaultOption}
        callback={handleMealPeriod}
        disabled={disabled}
      />
    </MealPeriodDropdownContainer>
  );
}
